import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface States {
  editTabIndex: number;
}

const initialState: States = {
  editTabIndex: 0,
};

export const developerSlice = createSlice({
  initialState,
  name: 'developer',
  reducers: {
    setEditTabIndex: (state, { payload }: PayloadAction<number>) => {
      state.editTabIndex = payload;
    },
  },
});

export default developerSlice.reducer;

export const { setEditTabIndex: setEditTabIndexAction } =
  developerSlice.actions;
